export default __webpack_public_path__ + "static/media/leap360.f814a015.png";